import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useLeftSidebarStore } from '@efacity/frontend-next-shared/header';
import { headerHeight } from '@efacity/common';

export interface MainContentProps {
  children: ReactNode;
  onMainContentClick: () => void;
}

export function Content({ children, onMainContentClick }: MainContentProps) {
  const isExpanded = useLeftSidebarStore((state) => state.isExpanded);

  return (
    <Box
      sx={{
        flexGrow: 1,
        px: 4,
        marginLeft: { xs: 0, sm: 0, md: isExpanded ? '260px' : '26px' },
        padding: ' 0px 15px 30px 15px',
        height: `calc(100% - ${headerHeight}px)`,
        overflow: 'auto',
        transition: (theme) =>
          theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
          }),
        ...(!isExpanded && {
          transition: (theme) =>
            theme.transitions.create('margin', {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.leavingScreen
            }),
          ml: '40px',
          sm: {
            marginLeft: 0
          }
        })
      }}
      onClick={onMainContentClick}
    >
      {children}
    </Box>
  );
}
